const API_URL = process.env.REACT_APP_API_URL;

export async function login(body) {
  const payload = {
    utilisateur: {
      email: body.email,
      mot_de_passe: body.password
    },
    source: "intranet"
  };

  const response = await fetch(`${API_URL}/connexion`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    credentials: "include",
    body: JSON.stringify(payload),
  });

  const data = await response.json();


  if (!response.ok) {
    throw new Error(data?.message || "Erreur inconnue");
  }

  return data;
}

export async function loginMicrosoft(accessToken, refreshToken, email) {
  const response = await fetch(`${API_URL}/connexion/microsoft`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({
      source: "intranet",
      utilisateur: {
        email,
        microsoft_access_token: accessToken,
        microsoft_refresh_token: refreshToken,
      },
    }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data?.message || "Erreur lors de la connexion Microsoft");
  return data;
}

export async function loginGoogle(accessToken, email) {
  const response = await fetch(`${API_URL}/connexion/google`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({
      source: "intranet",
      utilisateur: {
        email,
        google_access_token: accessToken,
      },
    }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data?.message || "Erreur lors de la connexion Google");
  return data;
}



export async function getCurrentUser() {
  const response = await fetch(`${API_URL}/utilisateur/moi`, {
    method: "GET",
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Non authentifié");
  }

  return response.json();
}



export async function updatePassword(body) {
  const payload = {
    mot_de_passe: {
      actuel: body.oldPassword,  
      nouveau: body.newPassword, 
    },
  };

  const response = await fetch(`${API_URL}/utilisateur/${body.userId}/mot-de-passe`, {
    method: "PUT",
    credentials: "include",
    headers: { 
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify(payload),
  });
  
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
  
    throw new Error(errorData.detail || errorData.message || "Erreur lors de la mise à jour");
  }

  return response.json();
}

export async function forgotPassword(email) {
  const response = await fetch(`${API_URL}/mot-de-passe/envoyer-email-reinitialisation`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data?.message || "Erreur lors de l'envoi de l'email");
  return data;
}

export async function resetPassword(token, newPassword) {
  const response = await fetch(`${API_URL}/mot-de-passe/reinitialiser`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      mot_de_passe: {
        email: null,
        mot_de_passe: newPassword,
        token: token
      }
    }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data?.message || "Lien invalide ou expiré.");
  return data;
}

export async function logout() {
  const response = await fetch(`${API_URL}/deconnexion`, {
    method: "POST",
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Non authentifié");
  }

  return response.json();
}